// Setup › Recall at `/c/{slug}/setup/recall` (M7-04; managers, the `memory` add-on):
// features/memory/recall-screen. While the add-on is off a direct URL says "not enabled".
import { createRoute } from "@tanstack/react-router";
import { RecallScreen } from "../features/memory/recall-screen";
import { useCompany, useFeature } from "../features/use-feature";
import { NotEnabledPage } from "../pages/status-pages";
import { setupRoute } from "./c.$slug.setup";

export const setupRecallRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "recall",
  component: function Recall() {
    const { api } = setupRecallRoute.useRouteContext();
    const company = useCompany();
    const memory = useFeature("memory");
    if (!memory.enabled)
      return (
        <NotEnabledPage
          what="Recall"
          feature="memory"
          companyName={company.name}
          slug={company.slug}
        />
      );
    return <RecallScreen api={api} company={company} />;
  },
});
